export const baseBackground = 'var(--base-background)';
export const baseText = 'var(--base-text)';
export const whiteText = 'var(--white-text)';

export const dividerColor = 'var(--divider-color)';
export const selectedMessageBackground = 'var(--selected-message-background)';
export const selectedMessageText = 'var(--selected-message-text)';

export const formInputTextForFilledBack = 'var(--form-input-text-for-filled-back)';
export const blackText = 'var(--black-text)';
export const tabsTextColor = 'var(--tabs-text-color)';
export const tabActiveBackground = 'var(--tab-active-background)';
export const baseButtonsBorder = 'var(--base-buttons-border)';
export const black = 'var(--black)';
export const black1 = 'var(--black1)';
export const black2 = 'var(--black2)';
export const black3 = 'var(--black3)';
export const black4 = 'var(--black4)';
export const fullColoredButtonBackgroundBase = 'var(--full-colored-button-background-base)';
export const fullColoredButtonBackgroundActive = 'var(--full-colored-button-background-active)';
export const actionButtonSelected = 'var(--action-button-selected)';
export const tagPickerButtonsText = 'var(--tag-picker-buttons-text)';
export const copyButtonText = 'var(--copy-button-text)';
export const copyButtonBorder = 'var(--copy-button-border)';
export const deleteOrUndoButtonText = 'var(--delete-or-undo-button-text)';
export const deleteOrUndoButtonBorder = 'var(--delete-or-undo-button-border)';
export const decisionTreeButtonBorder = 'var(--decision-tree-button-border)';
export const decisionTreeButtonHoverBackground = 'var(--decision-tree-button-hover-background)';
export const baseSurveyButtonBackground = 'var(--base-survey-button-background)';
export const baseSurveyButtonHoverBackground = 'var(--base-survey-button-hover-background)';
export const baseSurveyButtonActiveBackground = 'var(--base-survey-button-active-background)';
export const baseSurveyButtonGradientUp = 'var(--base-survey-button-gradient-up)';
export const baseSurveyButtonGradientDown = 'var(--base-survey-button-gradient-down)';

export const popupContentText = 'var(--popup-content-text)';
export const popupRedText = 'var(--popup-red-text)';
export const popupGreenText = 'var(--popup-green-text)';
export const popupSubmitButton = 'var(--popup-submit-button)';
export const popupSubmitButtonBackgroundActive = 'var(--popup-submit-button-background-active)';
export const popupSubmitButtonBackgroundDisabled = 'var(--popup-submit-button-background-disabled)';
export const popupBlackListText = 'var(--popup-black-list-text)';
export const popupFullProgressBarBackground = 'var(--popup-full-progress-bar-background)';
export const popupCurrentProgressBarBackground = 'var(--popup-current-progress-bar-background)';
export const popupProgressBarLabelText = 'var(--popup-progress-bar-label-text)';
export const newTicketPopupHeaderBackground = 'var(--new-ticket-popup-header-background)';
export const popupBusinessNameText = 'var(--popup-business-name-text)';
export const popupHeaderBackground = 'var(--popup-header-background)';
export const popupHeaderText = 'var(--popup-header-text)';
export const lightBlack = 'var(--light-black)';
export const lightGray1 = 'var(--light-gray1)';
export const lightGray2 = 'var(--light-gray2)';
export const lightGray3 = 'var(--light-gray3)';
export const lightGray4 = 'var(--light-gray4)';
export const lightGray5 = 'var(--light-gray5)';
export const lightGray6 = 'var(--light-gray6)';
export const lightGray7 = 'var(--light-gray7)';
export const lightGray8 = 'var(--light-gray8)';
export const lightGray9 = 'var(--light-gray9)';
export const lightGray10 = 'var(--light-gray10)';
export const lightGray11 = 'var(--light-gray11)';
export const lightGray12 = 'var(--light-gray12)';
export const lightGray13 = 'var(--light-gray13)';
export const lightGray14 = 'var(--light-gray14)';
export const lightGray15 = 'var(--light-gray15)';
export const lightGray17 = 'var(--light-gray17)';
export const lightGray18 = 'var(--light-gray18)';
export const lightGray19 = 'var(--light-gray19)';
export const lightGray20 = 'var(--light-gray20)';
export const lightGray21 = 'var(--light-gray21)';
export const lightGray22 = 'var(--light-gray22)';
export const lightGray23 = 'var(--light-gray23)';
export const lightGray24 = 'var(--light-gray24)';
export const lightGray25 = 'var(--light-gray25)';
export const lightGray26 = 'var(--light-gray26)';
export const lightGray27 = 'var(--light-gray27)';
export const lightGray28 = 'var(--light-gray28)';
export const lightGray29 = 'var(--light-gray29)';
export const lightGray30 = 'var(--light-gray30)';
export const lightGray31 = 'var(--light-gray31)';
export const lightGray32 = 'var(--light-gray32)';
export const lightGray33 = 'var(--light-gray33)';
export const lightGray34 = 'var(--light-gray34)';
export const lightGray35 = 'var(--light-gray35)';
export const lightGray36 = 'var(--light-gray36)';
export const lightGray37 = 'var(--light-gray37)';
export const lightGray38 = 'var(--light-gray38)';
export const lightGray39 = 'var(--light-gray39)';
export const white = 'var(--white)';
export const lightWhite = 'var(--light-white)';
export const lightWhite2 = 'var(--light-white2)';
export const darkGray = 'var(--dark-gray)';
export const darkGray1 = 'var(--dark-gray1)';
export const darkGray2 = 'var(--dark-gray2)';
export const darkGray3 = 'var(--dark-gray3)';
export const darkGray4 = 'var(--dark-gray4)';
export const darkGray5 = 'var(--dark-gray5)';
export const darkGray6 = 'var(--dark-gray6)';
export const darkGray7 = 'var(--dark-gray7)';
export const darkGray8 = 'var(--dark-gray8)';
export const darkGray9 = 'var(--dark-gray9)';
export const darkGray10 = 'var(--dark-gray10)';
export const darkGray11 = 'var(--dark-gray11)';
export const darkGray12 = 'var(--dark-gray12)';
export const darkGray13 = 'var(--dark-gray13)';
export const darkGray14 = 'var(--dark-gray14)';
export const darkGray15 = 'var(--dark-gray15)';
export const darkGray16 = 'var(--dark-gray16)';
export const darkGray17 = 'var(--dark-gray17)';
export const darkGray18 = 'var(--dark-gray18)';
export const orange = 'var(--orange)';
export const orange2 = 'var(--orange2)';
export const orange3 = 'var(--orange3)';
export const darkWhite1 = 'var(--dark-white1)';
export const darkWhite2 = 'var(--dark-white2)';
export const green1 = 'var(--green1)';
export const green2 = 'var(--green2)';
export const green3 = 'var(--green3)';
export const green4 = 'var(--green4)';
export const green5 = 'var(--green5)';
export const darkGreen1 = 'var(--dark-green1)';
export const venetianRed = 'var(--venetian-red)';
export const red = 'var(--red)';
export const red2 = 'var(--red2)';
export const red3 = 'var(--red3)';
export const purple1 = 'var(--purple1)';
export const purple2 = 'var(--purple2)';
export const purple3 = 'var(--purple3)';
export const purple4 = 'var(--purple4)';
export const purple5 = 'var(--purple5)';
export const purple6 = 'var(--purple6)';
export const purple7 = 'var(--purple7)';
export const purple8 = 'var(--purple8)';
export const purple9 = 'var(--purple9)';
export const purple10 = 'var(--purple10)';
export const gray = 'var(--gray)';
export const dimGray = 'var(--dim-gray)';
export const gold = 'var(--gold)';
export const slateGray = 'var(--slate-gray)';

export const chatChannelHighlight = 'var(--chat-channel-highlight)';
export const emailChannelHighlight = 'var(--email-channel-highlight)';
export const twitterDMChannelHighlight = 'var(--twitter-dm-channel-highlight)';
export const simplrBlue = 'var(--simplr-blue)';
export const blue1 = 'var(--blue1)';
export const blue2 = 'var(--blue2)';
export const blue3 = 'var(--blue3)';
export const blue4 = 'var(--blue4)';
export const blue5 = 'var(--blue5)';
export const blue6 = 'var(--blue6)';
export const blue7 = 'var(--blue7)';
export const blue8 = 'var(--blue8)';
export const blue9 = 'var(--blue9)';
export const blue10 = 'var(--blue10)';
export const blue11 = 'var(--blue11)';
export const blue12 = 'var(--blue12)';
export const blue13 = 'var(--blue13)';

export const electricBlue = 'var(--electric-blue)';
export const aliceBlue = 'var(--alice-blue)';
export const gulfBlue = 'var(--gulf-blue)';
export const disabledBlue = 'var(--disabled-blue)';
export const activeInputGray = 'var(--active-input-gray)';
export const inputGrey = 'var(--input-grey)';

export const activeButtonColor = 'var(--active-button-color)';
export const blackTransparent = 'var(--black-transparent)';
export const darkOverlay = 'var(--dark-overlay)';
export const mischka = 'var(--mischka)';
export const navyBlue = 'var(--navy-blue)';

export const lavenderBlue = 'var(--lavender-blue)';
export const royalBlue = 'var(--royal-blue)';

export const intentValidation = {
  green1: 'var(--intent-validation-green1)',
  red1: 'var(--intent-validation-red1)',
  red2: 'var(--intent-validation-red2)',
};

export const dodgerBlueOpaque = 'var(--dodger-blue-opaque)';
export const navyBlueOpaque = 'var(--navy-blue-opaque)';
export const inboxListBg = 'var(--inbox-list-bg)';
export const filterTouchedBorder = 'var(--filterTouchedBorder)';
export const filterTooltipBg = 'var(--filterTooltipBg)';
export const filterTooltipText = 'var(--filterTooltipText)';
